"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Pass this as a child to the `SearchField` component to render a footer below
 * the suggestions in the search suggestion popover.
 *
 * Use this to add any contextual information or actions to the suggestions
 * (e.g. an "X results" label or a "More suggestions" link).
 */
var SearchSuggestionFooter = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchSuggestionFooter, _React$Component);

  var _super = _createSuper(SearchSuggestionFooter);

  function SearchSuggestionFooter() {
    (0, _classCallCheck2["default"])(this, SearchSuggestionFooter);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SearchSuggestionFooter, [{
    key: "render",
    value: function render() {
      // Actual rendering is done in ./search-suggestion-popover.js
      return this.props.children;
    }
  }]);
  return SearchSuggestionFooter;
}(_react["default"].Component);

SearchSuggestionFooter.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The elements to show in the footer. Plain text and links recommended.
   */
  children: _propTypes["default"].node.isRequired
} : {};
var _default = SearchSuggestionFooter;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/search-field/search-suggestion-footer.js
// module id = 394
// module chunks = 0